<template>
  <div>
    <el-dialog
      title="添加题目"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
      width="900px"
    >
      <div class="card">
        <div class="col-lg-12 list-header fix-header clearfix">
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="pageParams.content"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="搜索标题"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-form-select
              @change="search()"
              v-model="pageParams.type"
              class="form-select m-r-10"
              :options="statusList"
              type="text"
            ></b-form-select>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="search()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="app-list-sort">
            <b-dropdown>
              <template v-slot:button-content>
                <sort-icon />
              </template>
              <b-dropdown-item
                v-for="(item, index) in sortList"
                :key="index"
                @click="listSort(item)"
              >
                <span class="pull-left" v-if="pageParams.sortBy == item.value">
                  <i
                    v-if="pageParams.order == 'desc'"
                    class="bx bx-down-arrow-alt font-size-18 pull-left"
                  ></i>
                  <i
                    v-if="pageParams.order == 'asc'"
                    class="bx bx-up-arrow-alt font-size-18"
                  ></i>
                </span>
                <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                  item.text
                }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th>
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">标题题目</th>
                  <th scope="col">状态</th>
                  <th scope="col">题目类型</th>
                  <th scope="col">创建人</th>
                  <th scope="col">更新时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="media-dialog-radio">
                    <b-form-checkbox
                      v-model="selectItems"
                      :value="item"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-200px white-inherit">
                    {{ item.title || "--" }}
                  </td>
                  <td>
                    <span v-if="item.state == 1" class="dsply-fix status-open"
                      ><i></i>启用</span
                    >
                    <span v-if="item.state == 0" class="dsply-fix status-off"
                      ><i></i>禁用</span
                    >
                  </td>
                  <td>{{ checkType(item.type) }}</td>
                  <td>
                    {{ item.creator || "--" }}
                  </td>
                  <td>
                    {{ item.updatedAt || "--" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <app-list-loading ref="loading"></app-list-loading>
        </div>
        <pagination ref="page" @pageCallback="pageCallback"></pagination>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import content from "../../../../server/api/videoGather";
import pagination from "@/components/pagination/pagination.vue";
import question from "@/server/api/question";

export default {
  components: { pagination },
  data() {
    return {
      pageParams: {
        page: 1,
        pageSize: 30,
        type: "",
        content: "",
        state: "",
        sortBy: "createdAt",
        order: "desc",
        questionnaireId: "",
      },
      tagList: [],
      // currentTag: "",
      selectItems: [],
      allListIds: [],
      indeterminate: false, //全选
      items: [],
      show: false,
      sortList: [{ text: "更新时间", value: "updatedAt" }],
      statusList: [
        { text: "题目类型", value: "" },
        { text: "单选", value: 0 },
        { text: "多选", value: 1 },
        { text: "判断", value: 2 },
        { text: "排序", value: 5 },
        { text: "单选填空", value: 3 },
        { text: "多选填空", value: 4 },
      ],
    };
  },

  props: {},

  mounted() {
    // this.tagSearch();
  },
  methods: {
    showModel(id) {
      if (id) {
        this.pageParams.questionnaireId = Number(id);
      }

      this.indeterminate = false;
      this.selectItems = [];
      let that = this;
      setTimeout(function (argument) {
        that.resetParams();
      }, 500);
      // that.getTags();
      this.items = [];
      that.show = true;
    },

    handleClose() {
      this.show = false;
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        if (obj.ps == 100) {
          this.pageParams.pageSize = 100;
          this.getList();
        } else if (obj.ps == 50) {
          this.pageParams.pageSize = 50;
          this.getList();
        } else {
          this.pageParams.pageSize = 30;
          this.getList();
        }
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //获取列表数据
    getList() {
      // let params = this.utils.getQuery(this.pageParams);
      let params = this.pageParams;

      this.items = [];
      this.$refs.loading.show();
      question.questionList(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data && resp.data.items) {
            if (this.$refs.loading) {
              this.$refs.loading.hide(resp.data.items);
            }
            this.items = resp.data.items;
            this.allListIds = this.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        }
      });
    },

    submitCreate() {
      console.log(this.selectItems);
      let current = {
        code: "topic",
        item: this.selectItems,
      };
      this.handleClose();
      this.$emit("pageCallback", current);
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      // this.pageParams.page = 1;
      // this.pageParams.tagId = "";
      // this.currentTag = [];
      this.pageParams.content = "";
      this.pageParams.type = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.selectItems = this.allListIds;
      } else {
        this.selectItems = [];
      }
    },
    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "asc"; //默认正序
      }
      this.getList();
    },
    //判断类型
    checkType(num) {
      if (num == 0) {
        return "单选";
      }
      if (num == 1) {
        return "多选";
      }
      if (num == 2) {
        return "判断";
      }
      if (num == 3) {
        return "单项填空";
      }
      if (num == 4) {
        return "多项填空";
      }
      if (num == 5) {
        return "排序";
      }
    },
  },
};
</script>
